import * as React from "react";
import {websiteUrl} from "config";

export enum NACH_STATUS {
  ACTIVATED= "ACTIVATED",
  IN_PROCESS = "IN_PROCESS",
  REJECTED = "REJECTED",
}

export const NACH_STATUS_TEXT = {
  [NACH_STATUS.IN_PROCESS]: "Your auto debit(NACH) mandate is under registration. Please check with your bank for further updates.",
  [NACH_STATUS.REJECTED]: "Your auto debit(NACH) mandate has been rejected. Please transfer your EMI to our lender account.",
  [NACH_STATUS.ACTIVATED]: "Your auto debit(NACH) mandate is active. Please maintain sufficient balance ahead of your EMI date.",
};

export const REPAYMENT_ACCOUNT_TEXT = {
  [NACH_STATUS.IN_PROCESS]: "Your auto-debit mandate has not been activated yet. Please pay your EMI to the following account",
  [NACH_STATUS.REJECTED]: "Your auto-debit mandate is rejected. Please pay your EMI to the following account.",
};

export const LOAN_APPROVE_STATUS = [
  "CUST_CONSENT_PENDING",
  "CUST_CONSENT_GIVEN",
  "AGENT_ASSIGNED",
  "DOC_RECEIVED_BY_AGENT",
  "DOC_PROCESSING",
  "VERIFYING_DOCS",
  "RE_DOC_REQUESTED",
  "DISBURSAL_PENDING",
];

export const convertObjectToString = (params: {[key: string]: any}) => {
  let paramtoString: string[] = [];
  Object.keys(params).forEach(key =>
    paramtoString.push(`${key.indexOf('_') !== -1 ?
    key.split('_').map((w, i) => i === 0 ? w.substring(0,1).toUpperCase()+ w.substring(1): w).join(' '): key}: ${params[key]}`));
  return params instanceof Object && params.constructor === Object ? paramtoString.join(', ') : params;
}

export const CardRow = ({title, value}) => {
  return(
    <div className="row">
      <span className="left">{title}</span>
      <span className="right">{value}</span>
    </div>
  );
};

export const RepaymentLink = {
  EKAGRATA: `${websiteUrl}/repayment/#/`,
  DMI: "https://paytm.com/loan-emi-payment/dmi-finance",
  INCRED: "https://www.incred.com/payment/payment.html#/",
  AXIS: "https://easypay.axisbank.co.in/easyPay/makePayment?mid=NTQ1NDY%3D",
  FULLERTON: "https://bit.ly/313Mxwu",
  RBL: "https://paytm.com/loan-emi-payment/rbl-bank-ltd",
};
